<template>
  <div>
      <header>
      <div class="header-content">
        <div class="container">
          <div>
            <div class="header-text-content">
              <h1>
                Création de sites internet et d'app web!
              </h1>
              <p>
                Un simple site vitrine ou une solution applicative complexe, nous avons la solution idéale pour répondre à vos besoins.
              </p>
              <div>
                <a class="link-more nav-btn" href="#about"><i class="g3i g3i-carret-bottom g3i-sm"></i> en savoir plus</a>
              </div>
            </div>
          </div>
          <div>
            <div class="header-img-content">
              <img class="desktop" src="@/assets/images/window-header.svg" alt="">
              <img class="phone" src="@/assets/images/phone.svg" alt="">
            </div>
          </div>
        </div>
      </div>
    </header>
    <svg class="header-frame" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" viewBox="0 0 1920 310"><title>header-frame</title><path class="cls-1" d="M0,283.054c22.75,12.98,53.1,15.2,70.635,14.808,92.115-2.077,238.3-79.9,354.895-79.938,59.97-.019,106.17,18.059,141.58,34,47.778,21.511,47.778,21.511,90,38.938,28.418,11.731,85.344,26.169,152.992,17.971,68.127-8.255,115.933-34.963,166.492-67.393,37.467-24.032,148.6-112.008,171.753-127.963,27.951-19.26,87.771-81.155,180.71-89.341,72.016-6.343,105.479,12.388,157.434,35.467,69.73,30.976,168.93,92.28,256.514,89.405,100.992-3.315,140.276-41.7,177-64.9V0.24H0V283.054Z"></path></svg>
  </div>
</template>

<script>
export default {
    name: 'Header',
    mounted () {
        document.querySelector('.header-img-content .desktop').animate([
            // keyframes
            { transform: 'translateX(800px)', opacity: '0' },
            { transform: 'translateX(100px) rotate(7deg)', opacity: '1' },
        ], { 
            // timing options
            duration: 800,
            iterations: 1,
            easing: 'ease-out',
            fill: 'forwards'
        });
        document.querySelector('.header-img-content .phone').animate([
            // keyframes
            { transform: 'translateX(800px)', opacity: '3' },
            { transform: 'translateX(20px)  rotate(-9deg)', opacity: '1' },
        ], { 
            // timing options
            delay: 600,
            duration: 800,
            iterations: 1,
            easing: 'ease-out',
            fill: 'forwards'
        });
    },
}
</script>

<style lang="scss">
header{
  height: 65vh;
  width: 100%;
  @include mq1280{
    height: 80vh;
  }
}
header{
  background-color: $main-color;
  .header-content{
    height: 100%;
  }
  .container{
    display: flex;
    align-items: center;
    height: 100%;
    
    & > div{
      width: 50%;
      .header-text-content{
        margin: 200px 0 0 90px;
        h1{
          font-size: 52px;
          margin-bottom: 45px;
        }
        p{
          font-family: $link-font;
          letter-spacing: .8px;
          font-size: 20px;
          margin-right: 90px;
          margin-left: 2px;
          line-height: 26px;
        }
        .link-more{
          margin-top: 45px;
          display: block;
          color: white;
          font-family: $content-font;
          font-size: 15px;
          i{
            margin-right: 10px;
          }
        }
        @include mq1280{
          margin: 100px 0 0 25px;
        }
        @include mq768{
          margin: 80px 0 0 0;
        }
      }
      .header-img-content{
        position: relative;
        .desktop{
            top: -100px;
            position: absolute;
            max-width: 600px;
            z-index: 1;
            transform: translateX(400px);
            filter: drop-shadow(4px 4px 6px rgba(0,0,0,.4));
            opacity: 0
        }
        .phone{
            top: -25px;
            position: absolute;
            transform: rotate(15deg) translate(400px, 0);
            max-width: 180px;
            opacity: 0;
            z-index: 2;
            filter: drop-shadow(4px 4px 6px rgba(0,0,0,.6));
        }
      }
    }
    @include mq1440{
      & > div{
        width: 40%;
        .header-text-content{
          h1{
              font-size: 38px;
          }
        }
      }
    }
    @include mq768{
      flex-direction: column;
      & > div{
        width: 100%;
        .header-text-content{
          width: 100%;
          text-align: center;
          padding: 0 15px;
          h1{
            font-size: 32px;
            margin-bottom: 15px;
          }
          p{
            margin: 0;
            font-size: 16px;
          }
          .link-more{
            margin-top: 20px;
            margin-bottom: 15px;
          }
        }
        .header-img-content{
          .desktop{
            top: 40px;
            left: -10px;
            max-width: 60%;
            width: 100%;
            margin:0 auto;
          }
          .phone{
            top: 60px;
            left: 15px;
            max-width: 25%;
            width: 100%;
            margin:0 auto;
          }
        }
      }
    }
    @include mq576{
      & > div{
        .header-img-content{
          .desktop{
            top: 40px;
            left: -10px;
            max-width: 60%;
            width: 100%;
            margin:0 auto;
          }
          .phone{
            top: 60px;
            left: 15px;
            max-width: 25%;
            width: 100%;
            margin:0 auto;
          }
        }
      }
    }
  }
  h1, p{
    color: white;
  }
  
}
.header-frame {
  height: 9.375rem;
  width: 100%;
  margin-top: -1px;
  overflow: hidden;
  vertical-align: middle;
  path.cls-1{
    fill: $main-color;
  }
  
}
</style>